import type { CSSProperties } from 'react';
import classnames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Feedback } from '../elements/common';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface ICheckboxInputProps {
    automation?: string;
    checked: boolean;
    checkOnTextClickedDisabled?: boolean;
    disabled?: boolean;
    error?: string;
    hasFormControl?: boolean;
    isRequired?: boolean;
    labelStyle?: CSSProperties;
    name?: string;
    onChange: (value: boolean) => void;
    onDoValidate?: () => void;
    text?: string | React.ReactNode;
    textStyle?: CSSProperties;
}

export function CheckboxInput(props: FormContextProps<ICheckboxInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                const labelClassName = classnames(
                    'custom-control custom-checkbox',
                    { disabled: properties.disabled },
                    { 'has-formcontrol': properties.hasFormControl }
                );

                return (
                    <div className="form-check">
                        <label
                            className={labelClassName}
                            data-dd-privacy="allow"
                            style={properties.labelStyle}
                        >
                            <input
                                checked={props.checked || properties.checked}
                                className="custom-control-input"
                                disabled={props.disabled || properties.disabled}
                                name={props.name || properties.name}
                                onChange={async (e) => {
                                    await properties.onChange(e.target.checked);
                                    if (props.onDoValidate) {
                                        await props.onDoValidate();
                                    } else if (properties.onDoValidate) {
                                        await properties.onDoValidate();
                                    }
                                }}
                                type="checkbox"
                            />
                            <span className="custom-control-indicator"></span>
                            <span
                                className={classnames(
                                    'custom-control-description',
                                    props.automation ? 'automation-' + props.automation : '',
                                    props.checkOnTextClickedDisabled ? 'separate-from-checkbox' : ''
                                )}
                                onClick={(e) => {
                                    if (props.checkOnTextClickedDisabled) {
                                        e.preventDefault();
                                    }
                                }}
                                style={properties.textStyle || properties.labelStyle}
                            >
                                {props.text || properties.text}
                            </span>
                            {properties.isRequired && <span className="required">*</span>}
                        </label>
                        <Feedback error={props.error || properties.error} />
                    </div>
                );
            }}
        </FormContextConsumer>
    );
}

export function CheckboxField(props: FormContextProps<ICheckboxInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <CheckboxInput {...props} />
        </Field>
    );
}
